exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui.small.avatar.image {\n  margin: auto; }\n\n.ui.top.attached.tabular.menu {\n  border: none; }\n  .ui.top.attached.tabular.menu .item {\n    background: none;\n    color: white; }\n    .ui.top.attached.tabular.menu .item.active {\n      border-bottom: 2px solid white;\n      border-top: none;\n      border-left: none;\n      border-right: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainsAbout/MainsAbout.scss
// module id = 1304
// module chunks = 0